import {AiReviewUsageBasicInfo} from 'src/openapi/models/AiReviewUsageBasicInfo';

export const sortAiAssistData = (
    aiReviewUsageBasicInfo: AiReviewUsageBasicInfo[],
): AiReviewUsageBasicInfo[] => {
    return [...aiReviewUsageBasicInfo.toSorted((a, b) => {
        return (b?.changeRequestUpdateDate ?? '').localeCompare(a?.changeRequestUpdateDate ?? '');
    })];
};
